import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c85d8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.7rem"} }
const _hoisted_2 = {
  class: "white-radius",
  style: {"padding":"0"}
}
const _hoisted_3 = {
  class: "white-radius",
  style: {"padding-top":"0"}
}
const _hoisted_4 = {
  class: "cls-con",
  style: {"font-size":"0.9rem !important"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "合计数量 ：", -1))
const _hoisted_6 = { class: "price" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white-radius cls-con" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "desc",
    style: {"font-size":"0.9rem"}
  }, "支付方式"),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.9rem"} }, "套餐")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"3rem"} }, null, -1))
const _hoisted_9 = { class: "btn-con" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.3rem"} }, "确认提交", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_serve_item = _resolveComponent("serve-item")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_field, {
          modelValue: _ctx.config.orderData.orderName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.orderData.orderName) = $event)),
          label: "预约人",
          border: false,
          placeholder: "请输入预约人姓名"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: _ctx.config.orderData.orderPhone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.orderData.orderPhone) = $event)),
          type: "tel",
          label: "联系电话",
          border: false,
          placeholder: "请输入联系电话"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: "",
          modelValue: _ctx.arrivalDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.arrivalDate) = $event)),
          label: "到店时间",
          border: false,
          placeholder: "请选择到店日期（最多可选7天）",
          "is-link": "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.config.showDate = true))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serveArr, (item) => {
          return (_openBlock(), _createBlock(_component_serve_item, {
            key: item.id,
            item: item
          }, null, 8, ["item"]))
        }), 128)),
        _createVNode(_component_van_divider, { style: {"margin":"0.5rem 0"} }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.num) + " 次", 1)
        ])
      ]),
      _hoisted_7,
      _hoisted_8
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      overlay: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_button, {
            onClick: _ctx.submit_click,
            color: "#D8C14F",
            round: "",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: _ctx.config.showDate,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.showDate) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.config.showDate = false)),
          type: "datetime",
          onConfirm: _ctx.submit_date,
          title: "选择到店时间",
          "min-date": _ctx.config.curDate,
          "max-date": _ctx.config.date7
        }, null, 8, ["onConfirm", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.config.showTime,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.showTime) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.config.showTime = false)),
          type: "time",
          onConfirm: _ctx.submit_time,
          title: "选择服务时间",
          "min-hour": _ctx.tenantInfo.startHour,
          "max-hour": _ctx.tenantInfo.endHour
        }, null, 8, ["onConfirm", "min-hour", "max-hour"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}